var map = {
	"./metadata_alux_connect_lite.json": "./src/playground/blocks/hardwareLite/metadata_alux_connect_lite.json",
	"./metadata_alux_nemo_lite.json": "./src/playground/blocks/hardwareLite/metadata_alux_nemo_lite.json",
	"./metadata_alux_teachnic_normal_lite.json": "./src/playground/blocks/hardwareLite/metadata_alux_teachnic_normal_lite.json",
	"./metadata_alux_teachnic_power_lite.json": "./src/playground/blocks/hardwareLite/metadata_alux_teachnic_power_lite.json",
	"./metadata_arduino_lite.json": "./src/playground/blocks/hardwareLite/metadata_arduino_lite.json",
	"./metadata_choco_lite.json": "./src/playground/blocks/hardwareLite/metadata_choco_lite.json",
	"./metadata_cocodron_controller_Lite.json": "./src/playground/blocks/hardwareLite/metadata_cocodron_controller_Lite.json",
	"./metadata_codewiz_lite.json": "./src/playground/blocks/hardwareLite/metadata_codewiz_lite.json",
	"./metadata_hamster_lite.json": "./src/playground/blocks/hardwareLite/metadata_hamster_lite.json",
	"./metadata_microbit2_lite.json": "./src/playground/blocks/hardwareLite/metadata_microbit2_lite.json",
	"./metadata_microbit2ble_lite.json": "./src/playground/blocks/hardwareLite/metadata_microbit2ble_lite.json",
	"./metadata_neo_cannon_lite.json": "./src/playground/blocks/hardwareLite/metadata_neo_cannon_lite.json",
	"./metadata_neo_lite.json": "./src/playground/blocks/hardwareLite/metadata_neo_lite.json",
	"./metadata_neo_spider_lite.json": "./src/playground/blocks/hardwareLite/metadata_neo_spider_lite.json",
	"./metadata_neobot_purple_lite.json": "./src/playground/blocks/hardwareLite/metadata_neobot_purple_lite.json",
	"./metadata_neobot_soco_lite.json": "./src/playground/blocks/hardwareLite/metadata_neobot_soco_lite.json",
	"./metadata_neobot_thinkcar_lite.json": "./src/playground/blocks/hardwareLite/metadata_neobot_thinkcar_lite.json",
	"./metadata_robolink_ZumiMini_lite.json": "./src/playground/blocks/hardwareLite/metadata_robolink_ZumiMini_lite.json",
	"./metadata_robotis_kkokdu_lite.json": "./src/playground/blocks/hardwareLite/metadata_robotis_kkokdu_lite.json",
	"./metadata_robotis_koalabot_lite.json": "./src/playground/blocks/hardwareLite/metadata_robotis_koalabot_lite.json",
	"./metadata_robotis_rgee_lite.json": "./src/playground/blocks/hardwareLite/metadata_robotis_rgee_lite.json",
	"./metadata_robotis_rla_lite.json": "./src/playground/blocks/hardwareLite/metadata_robotis_rla_lite.json",
	"./metadata_robotis_robotai_lite.json": "./src/playground/blocks/hardwareLite/metadata_robotis_robotai_lite.json",
	"./metadata_sensorboard_lite.json": "./src/playground/blocks/hardwareLite/metadata_sensorboard_lite.json",
	"./metadata_whalesbot_drone_lite.json": "./src/playground/blocks/hardwareLite/metadata_whalesbot_drone_lite.json",
	"./metadata_wizwing_controller_lite.json": "./src/playground/blocks/hardwareLite/metadata_wizwing_controller_lite.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/playground/blocks/hardwareLite sync ^(?%21.*index.js)((.*_lite\\.(json))*$)im";